import React, { PropsWithChildren } from "react";
import { Offcanvas, OffcanvasProps } from "react-bootstrap";
import XIcon from "../icons/XIcon";
import "./BottomDrawer.scss";
import { GenericModalProps } from "../../utils/constants/generic-types";

interface BottomDrawerProps extends GenericModalProps {
  heading?: string;
  containerClass?: string;
  headingClass?: string;
  bodyClass?: string;
}

export default function BottomDrawer({
  children, isOpen, onClose, heading,
  containerClass, headingClass, bodyClass, ...props
}: PropsWithChildren<BottomDrawerProps & OffcanvasProps>) {
  return (
    <Offcanvas
      placement="bottom"
      show={isOpen}
      onHide={onClose}
      className={`MobileOnly BottomDrawer ${containerClass}`}
      {...props}
    >
      <Offcanvas.Header className={`p-0 justify-content-between ${headingClass}`}>
        <Offcanvas.Title>{heading}</Offcanvas.Title>
        <button aria-label="Close dialog" onClick={onClose} className="CloseButton">
          <XIcon />
        </button>
      </Offcanvas.Header>
      <Offcanvas.Body className={`p-0 ${bodyClass}`}>
        {children}
      </Offcanvas.Body>
    </Offcanvas>
  );
}
